import Cove from '@ctrack/cove';

let paConfig = {
  'api.bulk.maxConcurrentRequests': 5,
  'caseView.firstTab': 'parties'
};

Cove.setConfig(Object.assign({}, paConfig, window._config));
